/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Vc_Onl_Faq_6_AInputs */

const en_vc_onl_faq_6_a = /** @type {(inputs: Vc_Onl_Faq_6_AInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The current web build has a known font bug (VectorCraft issue #2689): it ships only Japanese fonts for its menus, so many Simplified Chinese, Traditional Chinese and Korean characters show as empty boxes. Until the ArtCraft team fixes it, we start the online version in English for Chinese and Korean browsers. You can still choose Chinese under Preferences, and the desktop apps display Chinese correctly with your system fonts.`)
};

const zh_vc_onl_faq_6_a = /** @type {(inputs: Vc_Onl_Faq_6_AInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`当前网页版有一个官方已知的字体问题（VectorCraft issue #2689）：菜单只内置了日文字体，很多简体中文、繁体中文和韩文字会显示成方框。在官方修复之前，本站让中文和韩文浏览器默认以英文界面打开在线版。你仍然可以在「首选项」里手动切换成中文；桌面版会使用系统字体，中文显示正常。`)
};

/**
* | output |
* | --- |
* | "The current web build has a known font bug (VectorCraft issue #2689): it ships only Japanese fonts for its menus, so many Simplified Chinese, Traditional Chi..." |
*
* @param {Vc_Onl_Faq_6_AInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const vc_onl_faq_6_a = /** @type {((inputs?: Vc_Onl_Faq_6_AInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Vc_Onl_Faq_6_AInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_vc_onl_faq_6_a(inputs)
	return zh_vc_onl_faq_6_a(inputs)
});
export { vc_onl_faq_6_a as "vc.onl.faq.6.a" }